import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(VContainer,{attrs:{"fluid":""}},[_c(VCard,{staticClass:"mx-auto",attrs:{"max-width":_setup.MAX_SCREEN_WIDTH}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.path})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }